import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateNewStudyAreaComponent } from './pages/create-new-study-area/create-new-study-area.component';

const createStudyAreaRoutes: Routes = [
  {
    path: 'manage-enterprises-license',
    component: CreateNewStudyAreaComponent,
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(createStudyAreaRoutes)],
})
export class CreateStudyAreaRoutingModule {
}
